/* Bildvorschau für Assets: zeichnet Pixel (auch asynchron geladene) in ein Canvas. */
import { useEffect, useRef, useState } from 'react';
import type { Pixels } from '../../formats/wad.ts';
import { drawPixels } from '../texture/widgets.tsx';

/** Canvas mit dem Bild; ohne Bild ein leerer Platzhalter gleicher Größe */
export function PixelsView(props: { px: Pixels | null; className?: string; label?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => { if (ref.current && props.px) drawPixels(ref.current, props.px); }, [props.px]);
  return <canvas ref={ref} className={'pxv' + (props.px ? '' : ' empty') + (props.className ? ' ' + props.className : '')} width={props.px?.w || 8} height={props.px?.h || 8} aria-label={props.label} role={props.label ? 'img' : undefined} />;
}

/** Lädt ein Bild; null bis es da ist oder wenn es keines gibt. Neu laden, wenn sich der Schlüssel ändert. */
export function usePixels(key: string, load: () => Promise<Pixels | null>): Pixels | null {
  const [state, setState] = useState<{ key: string; px: Pixels | null }>({ key: '', px: null });
  useEffect(() => {
    let alive = true;
    load().then((px) => { if (alive) setState({ key, px }); }, () => { if (alive) setState({ key, px: null }); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return state.key === key ? state.px : null;
}
